module.exports = __webpack_public_path__ + "img/ic_arrow_left.cd5b4212.svg";